import React from 'react';
import { Typography, CircularProgress } from '@mui/material';

interface FormulaResultProps {
    isCalculating: boolean;
    error: boolean;
    result: number | null | undefined;
}

/**
 * Displays the calculated formula result with loading, error, and success states.
 *
 * @param {FormulaResultProps} props
 * @returns {JSX.Element}
 */
const FormulaResult: React.FC<FormulaResultProps> = ({ isCalculating, error, result }) => {
    if (isCalculating) {
        return <CircularProgress size={16} sx={{ ml: 0.5 }} />;
    }

    if (error) {
        return <Typography variant="body2">Error calculating the formula</Typography>;
    }

    if (result !== null && result !== undefined) {
        return (
            <Typography variant="body2" fontWeight={600}>
                {result}
            </Typography>
        );
    }

    return <Typography variant="body2">-</Typography>;
};

export default FormulaResult;
